<template>
  <div class="pricelistsList">
		<v-content>
			<v-container fluid>
        <v-layout row wrap>
              <center style="width: 100%;"><img class="imgLoader" src="../shared/assets/images/3dloader.gif" v-if="loaded == false" /></center>
              <v-flex xs3>
                <div class="relative" v-if="loaded == true">
                  <a v-if="search != ''" @click.prevent="fncClearSearch" class="searchTypeClear"><i class="material-icons searchTypeClearText">close</i></a>
                  <v-text-field v-if="search != ''" label="Search" solo single-line v-model="search"></v-text-field>
                  <v-text-field append-icon="search" v-if="search == ''" label="Search" solo single-line v-model="search"></v-text-field><br />
                </div>
              </v-flex>
              <v-flex xs5>
                <p class="plistDefaultError" v-if="loaded == true && hasDefaultError == true">No default pricelist is set.<br />Only pricelists assigned specifically to the user or the user role will be used.</p>
              </v-flex>
        </v-layout>
				<v-data-table v-if="loaded == true" :headers="headers" :search="search" :items="pricelistList" class="elevation-1" :rows-per-page-items="[20,40,60,80,100]">
					<template slot="items" slot-scope="props">
						<td width="25%" >{{ props.item.pl_name }}</td>
						<td width="30%" >{{ props.item.pl_description }}</td>
						<td width="5%" >{{ fncCheckStatus(props.item.pl_active) }}</td>
						<td width="5%" >{{ props.item.pl_revision }}</td>
						<td width="5%" >{{ fncCheckStatus(props.item.pl_is_default) }}</td>
						<td width="5%" >{{ fncCheckStatus(props.item.pl_is_cost) }}</td>
						<td width="10%" >{{ props.item.pl_modified }}</td>
            <td width="10%" v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_PRICELISTS') !== -1" ><a @click.prevent="fncClonePricelist(props.item)"><i class="material-icons">compare_arrows</i></a></td>
						<td width="10%" v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_PRICELISTS') !== -1" ><a @click.prevent="fncEditPricelist(props.item)"><i class="material-icons">edit</i></a></td>
						<!--<td width="5%" v-if="objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_PRICELISTS') !== -1" ><a @click.prevent="fncDeletePricelist(props.item.pl_id)"><i class="material-icons">delete</i></a></td>-->
					</template>
				</v-data-table>
			</v-container>
		</v-content>
	</div>
</template>

<script>

  import { mapGetters } from 'vuex';
  import Modal from '@/components/shared/modal';

  export default {
	name: 'PrivList',
    data () {
		return {
			search: '',
			headers: [
				{ text: 'Name', value: 'pl_name', width: '25%' },
                { text: 'Description', value: 'pl_description', width: '30%' },
                { text: 'Active', value: 'pl_active', width: '5%' },
                { text: 'Revision', value: 'pl_revision', width: '5%' },
                { text: 'Default', value: 'pl_is_default', width: '5%' },
                { text: 'Cost List', value: 'pl_is_cost', width: '5%' },
                { text: 'Modified On', value: 'pl_modified', width: '10%' },
                { text: 'Clone', value: 'clone', width: '10%' },
                { text: 'Edit', value: 'edit', width: '10%' }
                /*{ text: 'Delete', value: 'delete', width: '5%' }*/
            ],
            loaded: false,
            hasDefaultError: true
		}
	},
    methods: {
      fncClearSearch() {
        this.search = '';
      },
      fncCheckStatus(statId) {
            if (statId === '1' || statId === true ) {
				return 'Yes';
			} else {
				return 'No';
			}
		},
		fncDeletePricelist(pid) {
			var deletePricelist = confirm('Are you sure you want to delete this pricelist?');
			if(deletePricelist === true) {
				this.$store.dispatch({
					type: 'fncDeletePricelist',
					pricelistId: pid
				})
			}
		},
        fncEditPricelist(objPricelist) {
			this.$store.dispatch({
				type: 'fncLockPricelist',
				obj: objPricelist
			})
			/*this.$store.commit({
				type: 'setPricelistEdit',
				obj: objPricelist
			});*/
			var modalDetails = { title: 'Edit Pricelist - ' + objPricelist.pl_name, component: 'modal-pricelist-edit', mstate: true, params: { editObj: objPricelist } };
			this.$store.commit({
				type: 'setModal',
				details: modalDetails
			});
		},
		fncClonePricelist(objPricelist) {
			var modalDetails = { title: 'Clone Pricelist - ' + objPricelist.pl_name, component: 'modal-pricelist-clone', mstate: true, params: {pl_id: objPricelist.pl_id} };
			this.$store.commit({
				type: 'setModal',
				details: modalDetails
			});
		}
	},
	computed: {
		...mapGetters([
			'objAuthorize',
			'pricelistList',
      'priceTableDetails',
      'priceTableAll',
      'priceTableAllSelected'
		])
	},
	beforeMount() {
		this.$store.dispatch('fncPopulatePricelistList');
		this.$store.dispatch('fncPopulatePricingTable');
	},
	created() {
		if( this.objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_PRICELISTS') === -1 ) {
			this.headers = [
				{ text: 'Name', value: 'pl_name' },
				{ text: 'Description', value: 'pl_description' },
				{ text: 'Active', value: 'pl_active' },
				{ text: 'Revision', value: 'pl_revision' },
				{ text: 'Default', value: 'pl_is_default' },
				{ text: 'Cost List', value: 'pl_is_cost' },
				{ text: 'Modified On', value: 'pl_modified' }
			]
        }
        if (this.pricelistList != '' ) {
          this.loaded = true
        }
    },
    watch: {
      pricelistList() {
        if (this.pricelistList == '' ) {
          this.loaded = false;
        } else {
          this.loaded = true;
          for( var p in this.pricelistList ) {
            if( this.pricelistList[p].pl_is_default == 1 || this.pricelistList[p].pl_is_default == true ) {
              this.hasDefaultError = false;
            }
          }
        }
      }
    }
}
</script>

<style scoped>

</style>
